<template>
  <div class="p-dropdown-menu-animation">
    <button
      class="p-dropdown-menu-animation__trigger"
      @click="$_dropdownAnimation_toggleState"
    >
      <slot name="trigger" />
      <span ref="arrowElement" class="p-dropdown-menu-animation__arrow">
        <slot name="arrow" />
      </span>
    </button>

    <div ref="targetElement" class="p-dropdown-menu-animation__target">
      <div
        ref="targetContentsElement"
        class="p-dropdown-menu-animation__target__inner"
      >
        <slot name="target" />
      </div>
    </div>
  </div>
</template>

<script>
//import dropdownAnimation from 'assets/js/mixins/dropdownAnimation'
import { Options, Vue } from "vue-class-component";
import { mixins } from "vue-class-component";
import DropdownAnimation from "@/general/mixins/dropdownAnimation.ts";

@Options
export default class DropdownMenuAnimation extends mixins(DropdownAnimation) {}
</script>

<style lang="scss" scoped>
.p-dropdown-menu-animation {
  &__trigger {
    width: 100%;
    display: block;
    position: relative;
  }

  &__arrow {
    position: absolute;
    right: 0;
    top: 25%;
  }

  &__target {
    overflow: hidden;

    &__inner {
    }
  }
}
</style>
